import axiosWrapper from '../../utilities/axios-wrapper'
import urlBuilder from '../../utilities/url-builder'
import API_ENDPOINTS from '../../constants/api-endpoints'
import axios from 'axios'
import { useCallback, useState } from 'react'
import moment from 'moment'
import { useQuery } from 'react-query'
import useStaleTimes from '../use-stale-times'

/*
    Simple use:
    api.get(endpoints.learningResources)

    Using parameters
    api.post(url(endpoints.learningResources, { resourceId: '123' }))

    Using Query parameters
    api.post(url(endpoints.learningResources, {}, { limit: 5 }))
*/

const useApi = () => {

    const staleTimes = useStaleTimes()

    const {
        isLoading,
        data: version,
    } = useQuery(
        'apiVersion',
        () => axiosWrapper.get(API_ENDPOINTS.version),
        {
            staleTime: staleTimes.MINUTE * 5,
            retry: 3,
        }
    )

    const setAuthorizationToken = useCallback(authorizationToken => {
        axios.defaults.headers.common['Authorization'] = authorizationToken;
    }, [])

    const formatDate = useCallback(date => {
        return date ? moment(date).format('MM/DD/YYYY') : undefined
    }, [])

    return {
        isLoading,
        isAvailable: Boolean(version),
        version,
        api: axiosWrapper,
        url: urlBuilder,
        endpoints: API_ENDPOINTS,
        setAuthorizationToken,
        time: staleTimes,
        formatDate,
    }
}

export default useApi